/*
import { useState } from "react";
import { useStrainsByType } from "../hooks/useCannabisData";

function SubcategorySelect({ category, value, onChange }) {
  const { strains } = useStrainsByType(category);
  const [inputValue, setInputValue] = useState(value || "");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleChange = (e) => {
    const typed = e.target.value;
    setInputValue(typed);
    onChange(typed); // keep parent in sync even before selecting

    if (typed.length < 1) {
      setSuggestions([]);
      return;
    }

    const filtered = strains
      .filter((s) =>
        String(s.Strain).toLowerCase().includes(typed.toLowerCase())
      )
      .slice(0, 10); // cap at 10 suggestions

    setSuggestions(filtered);
    setShowSuggestions(true);
  };

  const handleSelect = (strain) => {
    setInputValue(String(strain.Strain));
    onChange(String(strain.Strain));
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleBlur = () => {
    // Small delay so click on suggestion registers before hiding
    setTimeout(() => setShowSuggestions(false), 150);
  };

  return (
    <div className="autocomplete-wrapper" style={{ position: "relative" }}>
      <label>
        Strain
        <input
          type="text"
          value={inputValue}
          onChange={handleChange}
          onFocus={() => inputValue && setShowSuggestions(true)}
          onBlur={handleBlur}
          placeholder="Start typing a strain name..."
          autoComplete="off"
        />
      </label>

      {showSuggestions && suggestions.length > 0 && (
        <ul
          className="autocomplete-suggestions"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 100,
            listStyle: "none",
            margin: 0,
            padding: 0,
            border: "1px solid #ccc",
            background: "#fff",
            maxHeight: "220px",
            color: "#000",
            overflowY: "auto",
          }}
        >
          {suggestions.map((s) => (
            <li
              key={s.Strain}
              onMouseDown={() => handleSelect(s)} // mouseDown fires before blur
              style={{ padding: "8px 12px", cursor: "pointer" }}
            >
              {s.Strain}
              {s.Type && (
                <span style={{ marginLeft: 8, fontSize: "0.8em", color: "#888" }}>
                  {s.Type}
                </span>
              )}
              {s.Rating && (
                <span style={{ marginLeft: 8, fontSize: "0.8em", color: "#888" }}>
                  {s.Rating}★
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SubcategorySelect;
*/import { useState } from "react";
import { useStrainsByType } from "../hooks/useCannabisData";

function SubcategorySelect({ category, value, onChange, onStrainSelect }) {
  const { strains } = useStrainsByType(category);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedStrain, setSelectedStrain] = useState(null);

  const displayValue = String(value || "").replace(/-/g, " ");

  const handleChange = (e) => {
    const typed = e.target.value;
    onChange(typed);

    setSelectedStrain(null);

    if (typed.length < 1) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const matchText = typed.toLowerCase().replace(/\s+/g, "-");
    const filtered = strains
      .filter((s) =>
        String(s.Strain).toLowerCase().includes(matchText) ||
        String(s.Strain).toLowerCase().includes(typed.toLowerCase())
      )
      .slice(0, 10);

    setSuggestions(filtered);
    setShowSuggestions(true);
  };

  const handleSelect = (strain) => {
    const selected = String(strain.Strain);
    onChange(selected);
    setSelectedStrain(strain);
    onStrainSelect && onStrainSelect(strain);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleBlur = () => {
    setTimeout(() => setShowSuggestions(false), 150);
  };

  return (
    <div className="autocomplete-wrapper" style={{ position: "relative" }}>
      <label>
        Strain
        <input
          type="text"
          value={displayValue}
          onChange={handleChange}
          onFocus={() => displayValue && setShowSuggestions(true)}
          onBlur={handleBlur}
          placeholder="Start typing a strain name..."
          autoComplete="off"
        />
      </label>

      {showSuggestions && suggestions.length > 0 && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 100,
            listStyle: "none",
            margin: 0,
            padding: 0,
            border: "1px solid rgba(255,255,255,0.1)",
            background: "rgba(8, 16, 32, 0.95)",
            maxHeight: "220px",
            overflowY: "auto",
            borderRadius: "0 0 8px 8px",
          }}
        >
          {suggestions.map((s) => (
            <li
              key={s.Strain}
              onMouseDown={() => handleSelect(s)}
              style={{ padding: "8px 12px", cursor: "pointer" }}
            >
              {String(s.Strain).replace(/-/g, " ")}
              {s.Type && (
                <span style={{ marginLeft: 8, fontSize: "0.8em", opacity: 0.6 }}>
                  {s.Type}
                </span>
              )}
              {s.Rating && (
                <span style={{ marginLeft: 8, fontSize: "0.8em", opacity: 0.6 }}>
                  {s.Rating}★
                </span>
              )}
            </li>
          ))}
        </ul>
      )}

      {selectedStrain && selectedStrain.Effects && (
        <div style={{ marginTop: "8px", fontSize: "12px", opacity: 0.7, fontStyle: "italic" }}>
          Known effects: {selectedStrain.Effects}
        </div>
      )}
    </div>
  );
}

export default SubcategorySelect;